import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import QuanLyThuChiNgoaiLeApi from "service/quanLyThuChiNgoaiLeApi";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";
export const ModalChiTietPhieu = (props) => {
  const [chiTietNgoaiLe, setChiTietNgoaiLe] = useState({});
  const detailPhieuThuChiNgoaiLe = () => {
    QuanLyThuChiNgoaiLeApi.chiTietThuChiNgoaiLe(props.thuchiId).then(
      (response) => {
        setChiTietNgoaiLe(response.data);
      }
    );
  };
  useEffect(() => {
    detailPhieuThuChiNgoaiLe();
  }, []);

  return (
    <Modal
      {...props}
      size="modal-new-size modal-new-size"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="mdi mdi-inbox-full"></i>
          </span>{" "}
          Chi tiết
        </h4>
        <button
          type="button"
          className="close-popup-new"
          data-dismiss="modal"
          aria-label="Close"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <form className="form tat-toan form-horizontal">
          <div className="form-body">
            <div className="card collapse-icon accordion-icon-rotate">
              <div
                id="headingCollapse253"
                className="card-header border-info"
                href="#collapse253"
                aria-expanded="true"
                aria-controls="collapse253"
              >
                <a
                  className="card-title lead info collapsed"
                  href={() => false}
                >
                  <h3>Chi tiết mã phiếu</h3>
                </a>
              </div>
              <div
                id="collapse253"
                aria-labelledby="headingCollapse253"
                className="card-collapse collapse show"
                aria-expanded="true"
              >
                <div className="card-content">
                  <div className="card-body">
                    <div className="form-body form-bordered-1">
                      <div className="form-group row">
                        <label className="col-md-3 label-control">
                          Nhân viên
                        </label>
                        <div className="col-md-9">
                          {chiTietNgoaiLe.CreatedUser}
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="col-md-3 label-control">
                          Người nhận
                        </label>
                        <div className="col-md-9">{chiTietNgoaiLe.Name}</div>
                      </div>
                      <div className="form-group row">
                        <label className="col-md-3 label-control">Ngày</label>
                        <div className="col-md-9">
                          {getDate(chiTietNgoaiLe.Time)}
                        </div>
                      </div>

                      <div className="form-group row">
                        <label className="col-md-3 label-control">
                          Số tiền
                        </label>
                        <div className="col-md-9">
                          {formatNumber(chiTietNgoaiLe.Value)}(Đồng)
                        </div>
                      </div>

                      <div className="form-group row">
                        <label className="col-md-3 label-control">
                          Loại phiếu
                        </label>
                        <div className="col-md-9">
                          {chiTietNgoaiLe.TypeName}
                        </div>
                      </div>

                      <div className="form-group row">
                        <label className="col-md-3 label-control">
                          Ghi chú
                        </label>
                        <div className="col-md-9">{chiTietNgoaiLe.Note}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer className="modal-footer">
        <a
          className="btn btn-new-main btn-closenew"
          data-dismiss="modal"
          href={() => false}
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>{" "}
          Đóng
        </a>
      </Modal.Footer>
    </Modal>
  );
};
